<template>
  <div>
    <template v-if="pack.channel === 'shopee_analysis_spoiler'">
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
          Spy vị trí ads
        </div>
        <div style="display: inline-block; width: 28%; text-align: right">
          <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
          <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
        </div>
      </div>
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
          Công cụ Shopee Trend
        </div>
        <div style="display: inline-block; width: 28%; text-align: right">
          <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
          <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
        </div>
      </div>
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
          Số lượng từ khóa theo dõi
        </div>
        <div style="display: inline-block; width: 28%; text-align: right">
          <span style="color: red; font-weight: 600">100 từ</span>
        </div>
      </div>
      <div style="height: 120px"></div>
    </template>

    <template v-if="pack.channel === 'shopee_analysis'">
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
          Phân tích thị trường
        </div>
        <div style="display: inline-block; width: 28%; text-align: right">
          <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
          <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
        </div>
      </div>
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 70%; padding-right: 10px; font-weight: 600">
          Phân tích đối thủ
        </div>
        <div style="display: inline-block; width: 28%; text-align: right">
          <i v-if="true" style="font-size: 15px; font-weight: bold" class="el-icon-check text-success"></i>
          <i v-else style="font-size: 15px; font-weight: bold" class="el-icon-close text-danger"></i>
        </div>
      </div>
      <div style="margin-bottom: 12px">
        <div style="display: inline-block; width: 60%; padding-right: 10px; font-weight: 600">
          Số shop phân tích
        </div>
        <div style="display: inline-block; width: 38%; text-align: right">
          <span style="color: red; font-weight: 600">Không giới hạn</span>
        </div>
      </div>
      <div style="height: 120px"></div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    pack: {
      type: Object,
      required: true
    }
  },

  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/pages/package/component/shopee_analysis_component.vue